"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const language_codes_types_1 = require("./language_codes_types");
const FlashTipTypeSchema = zod_1.z.union([
    zod_1.z.literal("ABSTRACT_WORD_ON_IMAGE_SELECTOR"),
    zod_1.z.literal("BASICS_OF_SPELLING"),
    zod_1.z.literal("EAR_TRAINER"),
    zod_1.z.literal("HOME_SCREEN_LOADED"),
    zod_1.z.literal("LEARN"),
    zod_1.z.literal("VOCAB_AND_GRAMMAR_SET"),
    zod_1.z.literal("VOCAB_AND_GRAMMAR_SETS"),
]);
const FlashTipSchema = zod_1.z.object({
    description: zod_1.z.string(),
    id: zod_1.z.string(),
    imageUrl: zod_1.z.string().optional(),
    languagePairs: language_codes_types_1.LanguagePairCodeSchema.array(),
    title: zod_1.z.string(),
    type: FlashTipTypeSchema,
});
//# sourceMappingURL=flash_tips.js.map